export default __webpack_public_path__ + "static/media/foundation.0f656853.png";